export const GA = {
  triggerEvent: ({ event, financeType }) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ProductName: financeType });
  }
};

export const GA_EVENTS = {
  PRODUCT_PAGE: "ProductPage",
  PRODUCT_REVIEW_PAGE: "ProductReviewPage",
  PRODUCT_APPLY: "ProductApply",
  PRODUCT_START: "ProductStart",
  PRODUCT_BASIC_INFORMATION: "ProductBasicInformation",
  PRODUCT_OTP_SUBMITTED: "Product_OTP-Submitted",
  COMPANY_INFORMATION_DETAILS_CONTINUE: "CompanyInformation_Details_Continue",
  COMPANY_INFORMATION_INDUSTRY_CONTINUE: "CompanyInformation_Industry_Continue",
  COMPANY_INFORMATION_LICENSE_CONTINUE: "CompanyInformation_License_Continue",
  POST_ELIGIBILITY_COMPANY_INFORMATION_DETAILS_CONTINUE:
    "PostEligibility_CompanyInformation_Details_Continue",
  POST_ELIGIBILITY_COMPANY_INFORMATION_CONTACT_CONTINUE:
    "PostEligibility_CompanyInformation_Contact_Continue",
  POST_ELIGIBILITY_COMPANY_INFORMATION_INDUSTRY_CONTINUE:
    "PostEligibility_CompanyInformation_Industry_Continue",
  POST_ELIGIBILITY_COMPANY_BANKING_RELATIONSHIP_CONTINUE:
    "PostEligibility_Company_BankingRelationship_Continue",
  POST_ELIGIBILITY_COMPANY_BRANCHES_CONTINUE:
    "PostEligibility_Company_BranchesAndSubsidiaries_Continue",
  POST_ELIGIBILITY_COMPANY_ANTICIPATED_TRANSACTIONS_CONTINUE:
    "PostEligibility_Company_AnticipatedTransactions_Continue",
  POST_ELIGIBILITY_COMPANY_PREFERRED_MAILING_ADDRESS_CONTINUE:
    "PostEligibility_Company_PreferredMailingAddress_Continue",
  POST_ELIGIBILITY_COMPANY_PREFERRED_CONTACT_INFO_CONTINUE:
    "PostEligibility_Company_PreferredContactInfo_Continue",
  COMPANY_INFORMATION_SUBMITTED: "CompanyInformation_Submitted",
  COMPANY_STAKEHOLDER_PERSONAL_INFORMATION_CONTINUE:
    "CompanyStakeholder_PersonalInformation_Continue",
  COMPANY_STAKEHOLDER_SIGNATORY_RIGHTS_CONTINUE: "CompanyStakeholder_SignatoryRights_Continue",

  COMPANY_STAKEHOLDER_SHAREHOLDING_CONTINUE: "CompanyStakeholder_ShareHolding_Continue",
  COMPANY_STAKEHOLDER_NATIONALITY_CONTINUE: "CompanyStakeholder_Nationality_Continue",
  COMPANY_STAKEHOLDER_COUNTRY_OF_RESIDENCE_CONTINUE:
    "CompanyStakeholder_CountryOfResidence_Continue",
  COMPANY_STAKEHOLDER_PREFERRED_CONTACT_CONTINUE: "CompanyStakeholder_PreferredContact_Continue",
  COMPANY_STAKEHOLDER_ADD_NEW_CONTINUE: "CompanyStakeholder_AddNew_Continue",
  COMPANY_STAKEHOLDER_SUBMITTED: "CompanyStakeholder_Submitted",
  // new events added//
  BORROW_AMOUNT_SUBMITTED: "BorrowAmount_Submitted",
  FINAL_QUESTION_SUBMITTED: "FinalQuestion_Submitted",
  UPLOAD_DOCUMENTS_SUBMITTED: "UploadDocuments_Submitted",
  AECB_CHECK_SUBMITTED: "AecbCheck_Submitted",
  POST_ELIGIBILITY_COMPANY_INFORMATION_SUBMITTED: "PostEligibility_CompanyInformation_Submitted",
  POST_ELIGIBILITY_COMPANY_STAKEHOLDER_HOME_COUNTRY_DETAILS_CONTINUE:
    "PostEligibility_CompanyStakeholder_HomeCountryDetails_Continue",
  POST_ELIGIBILITY_COMPANY_STAKEHOLDER_EMPLOYMENT_DETAILS_CONTINUE:
    "PostEligibility_CompanyStakeholder_EmploymentDetails_Continue",
  POST_ELIGIBILITY_COMPANY_STAKEHOLDER_SOURCE_OF_FUNDS_CONTINUE:
    "PostEligibility_CompanyStakeholder_SourceOfFunds_Continue",
  POST_ELIGIBILITY_COMPANY_STAKEHOLDER_RESIDENCE_ADDRESS_CONTINUE:
    "PostEligibility_CompanyStakeholder_ResidenceAddress_Continue",
  POST_ELIGIBILITY_COMPANY_STAKEHOLDER_PREFERRED_MAILING_ADDRESS_CONTINUE:
    "PostEligibility_CompanyStakeholder_PreferredContact_Continue",
  POST_ELIGIBILITY_COMPANY_STAKEHOLDER_SUBMITTED: "PostEligibility_CompanyStakeholder_Submitted",
  POST_ELIGIBILITY_UPLOAD_DOCUMENTS_SUBMITTED: "PostEligibility_UploadDocuments_Submitted",
  POST_ELIGIBILITY_UPLOAD_COMPANY_DOCUMENTS_CONTINUE:
    "PostEligibility_UploadCompanyDocuments_Continue",
  AECB_CONSENT_OTP_START: "AecbConsent_Otp_Start",
  AECB_CONSENT_OTP_SUBMITTED: "AecbConsent_Otp_Submitted",
  AECB_CONSENT_AUTHORIZED: "AecbConsent_Otp_Authorized",
  ADDITIONAL_DOCUMENTS_UPLOAD_OTP_START: "AdditionalDocumentsUpload_Otp_Start",
  ADDITIONAL_DOCUMENTS_UPLOAD_OTP_SUBMITTED: "AdditionalDocumentsUpload_Otp_Submitted",
  ADDITIONAL_DOCUMENTS_UPLOAD_SUBMITTED: "AdditionalDocumentsUpload_Submitted",
  DROPOFF_AUTHORIZE_OTP_START: "Dropoff_Authorize_Otp_Start",
  DROPOFF_AUTHORIZE_OTP_SUBMITTED: "Dropoff_Authorize_Otp_Submitted",
  DROPOFF_AUTHORIZE_REQUEST_SUBMITTED: "Dropoff_Authorize_Request_Submitted",
  ELIGIBILITY_SUBMITTED: "Eligibility_Submitted",
  EXISTING_CUSTOMER_WAIT_FOR_SALES_AGENT_SUBMITTED: "ExistingCustomer_WaitForSalesAgent_Submitted",
  SALES_INITIATE_WAIT_FOR_SALES_AGENT_SUBMITTED: "SalesInitiate_WaitForSalesAgent_Submitted",
  // ***** //
  FINAL_QUESTION_PREFERRED_MAILING_ADDRESS_CONTINUE:
    "FinalQuestion_Preferred_Mailing_Address_Continue",
  FINAL_QUESTION_BUSINESS_RELATIONSHIPS_CONTINUE: "FinalQuestion_BusinessRelationships_Continue",
  FINAL_QUESTION_BANKING_RELATIONSHIPS_CONTINUE: "FinalQuestion_BankingRelationships_Continue",
  FINAL_QUESTION_BRANCHES_CONTINUE: "FinalQuestion_Branches_Continue",
  FINAL_QUESTION_ANTICIPATED_CONTINUE: "FinalQuestion_Anticipated_Continue",
  FINAL_QUESTION_OFFICE_ADDRESS_CONTINUE: "FinalQuestion_Office_Address_Continue",
  FINAL_QUESTION_PREFERRED_CONTACT_CONTINUE: "FinalQuestion_Preferred_Contact_Continue",
  FINAL_QUESTION_DNFPB_STATUS_CONTINUE: "FinalQuestion_Dnfpb_Status_Continue",
  FINAL_QUESTION_PERSONAL_INFORMATION_CONTINUE: "FinalQuestion_PersonalInformation_Continue",
  FINAL_QUESTION_EMPLOYMENT_CONTINUE: "FinalQuestion_EmploymentDetails_Continue",
  FINAL_QUESTION_SOURCE_OF_FUND_CONTINUE: "FinalQuestion_SourceOfFund_Continue",
  FINAL_QUESTION_SOURCE_OF_FUND_SUBMITTED: "FinalQuestion_SourceOfFund_Submitted", // ???
  FINAL_QUESTION_RESIDENCE_ADDRESS_CONTINUE: "FinalQuestion_Residence_Address_Continue",
  FINAL_QUESTION_COMPANY_DNFBPSTATUS_CONTINUE: "FinalQuestion_Company_DNFBPStatus_Continue",
  SELECT_SERVICE_ACCOUNT_DETAILS_CONTINUE: "SelectService_AccountDetails_Continue",
  SELECT_SERVICE_SIGNING_PREFERENCE_CONTINUE: "SelectService_SigningPreference_Continue",
  SELECT_SERVICE_CHANNELS_CONTINUE: "SelectService_Channels_Continue",
  SELECT_SERVICE_KEEP_PLUS_UPGRADE_CONTINUE: "SelectService_KeepPlus_Upgrade_Continue",
  SELECT_SERVICE_SUBMITTED: "SelectService_Submitted",
  FORM_SUBMITTED: "FormSubmitted",
  COMEBACK_START: "ComeBackStart",
  COMEBACK_OTP_SUBMITTED: "ComeBack_OTP_Submitted",
  SA_COMPANY_STAKEHOLDER_INFO_CONTINUE: "CompanyStakeholder_StakeholderInfo_SalesAssist_Continue",
  SA_COMPANY_STAKEHOLDER_SIGNATORY_RIGHTS_CONTINUE:
    "CompanyStakeholder_SignatoryRights_SalesAssist_Continue",
  SA_COMPANY_STAKEHOLDER_SHAREHOLDING_CONTINUE:
    "CompanyStakeholder_ShareHolding_SalesAssist_Continue",
  SA_COMPANY_STAKEHOLDER_NATIONALITY_CONTINUE:
    "CompanyStakeholder_Nationality_SalesAssist_Continue",
  SA_COMPANY_STAKEHOLDER_COUNTRY_OF_RESIDENCE_CONTINUE:
    "CompanyStakeholder_Country_of_Residence_SalesAssist_Continue",
  SA_FINAL_QUESTION_BUSINESS_RELATIONSHIPS_CONTINUE:
    "FinalQuestion_BusinessRelationships_SalesAssist_Continue",
  SA_FINAL_QUESTION_RESIDENCE_ADDRESS_CONTINUE:
    "FinalQuestion_ResidenceAddress_SalesAssist_Continue",
  SA_FINAL_QUESTION_BANKING_RELATIONSHIPS_CONTINUE:
    "FinalQuestion_BankingRelationships_SalesAssist_Continue",
  SA_FINAL_QUESTION_BRANCHES_CONTINUE: "FinalQuestion_Branches_SalesAssist_Continue",
  SA_FINAL_QUESTION_ANTICIPATED_CONTINUE: "FinalQuestion_Anticipated_SalesAssist_Continue",
  SA_FINAL_QUESTION_GUARANTOR_CONTINUE: "FinalQuestion_Guarantor_SalesAssist_Continue",
  SA_FINAL_QUESTION_INWARD_CONTINUE: "FinalQuestion_Inward_Cheque_SalesAssist_Continue",
  SA_FINAL_QUESTION_OUTWARD_CONTINUE: "FinalQuestion_Outward_Cheque_SalesAssist_Continue",
  SA_FINAL_QUESTION_ADDITIONAL_SECURITY_CONTINUE:
    "FinalQuestion_Additional_Security_SalesAssist_Continue",
  SA_FINAL_QUESTION_POS_CONTINUE: "FinalQuestion_Pos_SalesAssist_Continue",
  SA_FINAL_QUESTION_COMPLIANCE_CONFIRMATION_CONTINUE:
    "FinalQuestion_Compliance_Confirmation_SalesAssist_Continue",
  SA_FINAL_QUESTION_ACCOUNT_ATTRIBUTES_CONTINUE:
    "FinalQuestion_Account_Attributes_SalesAssist_Continue",
  SA_FINAL_QUESTION_EID_VALIDATION_CONTINUE: "FinalQuestion_EID_Validation_SalesAssist_Continue",
  SA_COMPANY_INFORMATION_DETAILS_CONTINUE: "CompanyInformation_Details_Continue",
  SA_COMPANY_INFORMATION_CONTACT_CONTINUE: "CompanyInformation_Contact_Continue",
  SA_COMPANY_INFORMATION_INDUSTRY_CONTINUE: "CompanyInformation_Industry_Continue",
  SA_COMPANY_INFORMATION_LICENSE_CONTINUE: "CompanyInformation_License_Continue"
};
